import React, { useState, useEffect } from 'react';
import { Box, Alert, AlertTitle, Button, Collapse, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from './axiosConfig';

const SEVERITY_MAP = { info: 'info', warning: 'warning', urgent: 'error' };
const alertKey = r => r.alert_type || r.reminder_type;

const ReminderPanel = () => {
  const navigate = useNavigate();
  const [reminders, setReminders] = useState([]);
  const [dismissed, setDismissed] = useState(new Set());

  useEffect(() => {
    api.get('/dashboard/alerts')
      .then(res => setReminders(res.data || []))
      .catch(() => setReminders([]));
  }, []);

  const visible = reminders.filter(r => !dismissed.has(alertKey(r)));
  if (visible.length === 0) return null;

  return (
    <Stack spacing={1.5} sx={{ mb: 4 }}>
      {visible.map(r => (
        <Collapse key={alertKey(r)} in={!dismissed.has(alertKey(r))}>
          <Alert
            severity={SEVERITY_MAP[r.severity] || 'info'}
            onClose={() => setDismissed(prev => new Set(prev).add(alertKey(r)))}
            action={
              r.action_url && (
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => navigate(r.action_url)}
                  sx={{ fontWeight: 600 }}
                >
                  Review
                </Button>
              )
            }
          >
            <AlertTitle sx={{ fontWeight: 700 }}>{r.title}</AlertTitle>
            {r.message}
          </Alert>
        </Collapse>
      ))}
    </Stack>
  );
};

export default ReminderPanel;